import { Login } from '@/components/auth'

export default function LoginPage() {
  return <Login />
}
